export const FoodoGlobalEn = {
  companyProfile: {
    name: 'Foodo Global',
    about:
      'Foodo Global is a pioneering Qatari company specializing in providing ready-to-eat cooked meals with authentic Gulf, Arabic, and international Asian flavors. We serve households, local and global institutions through multiple channels including our website, delivery applications, local markets, and supermarkets.',
    aboutMobile:
      'Foodo Global is a leading company in offering ready-to-eat meals with diverse flavors. We are here to serve you anytime.',
    certifications:
      'All our meals are Halal-certified and ready to eat after heating, ensuring a complete and healthy meal anytime.',
    specialization:
      'Foodo specializes in producing ready-to-eat meals using advanced technology, offering a wide range of local and international dishes for breakfast, lunch, dinner, and special occasions.',
    whyChooseUs: [
      'Ready in just 1-2 minutes - perfect for modern, fast-paced lifestyle.',
      'Authentic Gulf, Arabic, and international Asian flavors.',
      'Ministry of Health licensed with strict quality control.',
      'Halal certified, fresh, and designed to maintain nutritional value.',
      'Long shelf life up to 2 years without refrigeration.',
      'Smart packaging technology for easy transport and storage.',
      'Multiple heating methods: microwave, oven, hot water, or self-heating pack.',
      'Suitable for all conditions and times.',
      'Supplies food materials and baskets to institutions and organizations.',
      'Available through website, apps, markets, and monthly subscription service.',
      'Prepared with natural ingredients and no preservatives.',
      'Contains all essential nutrients for a balanced diet.',
      'Perfect for breakfast, lunch, dinner, and special occasions.',
    ],
    whyChooseUsMobile: [
      'Ready in just 1-2 minutes - perfect for modern, fast-paced lifestyle.',
      'Authentic Gulf, Arabic, and international Asian flavors.',
      'Ministry of Health licensed with strict quality control.',
      'Halal certified, fresh, and designed to maintain nutritional value.',
      'Long shelf life up to 2 years without refrigeration.',
    ],
    slogan: 'Foodo meals offer a unique experience with delicious taste in every bite!',

    // Three Main Points Structure
    ourVision: {
      title: 'Our Vision',
      content:
        'Foodo Pioneering Gourmet Meals and Exceptional Global Flavor, with Superior Quality and Smart Technology',
    },
    ourMission: {
      title: 'Our Mission',
      content:
        'Redefinition of ready-meals, providing innovative food solutions and gourmet meals with authentic global flavors. We leverage smart technology to ensure the highest standards of quality, food safety, and extended shelf-life, empowering our customers with an exceptional meal in one minute.',
    },
    ourValues: {
      title: 'Our Values',
      content: [
        'Commitment to the highest quality standards in all our meals.',
        'Introducing new and innovative products that meet customer needs.',
        'Providing nutritious meals free of preservatives / Gluten Free.',
        'Implementing eco-friendly practices across our operations.',
        'Placing customer satisfaction at the heart of everything we do.',
      ],
    },

    // Legacy fields for backward compatibility
    vision:
      'Foodo Pioneering Gourmet Meals and Exceptional Global Flavor, with Superior Quality and Smart Technology',
    mission:
      'Redefinition of ready-meals, providing innovative food solutions and gourmet meals with authentic global flavors. We leverage smart technology to ensure the highest standards of quality, food safety, and extended shelf-life, empowering our customers with an exceptional meal in one minute.',
    values: [
      'Commitment to the highest quality standards in all our meals.',
      'Introducing new and innovative products that meet customer needs.',
      'Providing nutritious meals free of preservatives / Gluten Free.',
      'Implementing eco-friendly practices across our operations.',
      'Placing customer satisfaction at the heart of everything we do.',
    ],
    qualityStandards: [
      'Globally recognized Halal-certified meals.',
      'Strict food safety and quality control measures.',
      'Ongoing monitoring to maintain the highest standards.',
    ],
    availability: {
      orderOnline:
        'Order your favorite meals through our online store and enjoy fast delivery within Qatar.',
      location: 'Doha, Qatar - Al Gharafa',
      contact: {
        phone: '+974 40171730',
        email: 'info@foodo.qa',
        website: 'www.foodo.qa',
      },
    },
    closingStatement:
      'At Foodo Global, we bring you authentic Gulf, Arabic, and Asian flavors in ready-to-eat meals that combine quality, convenience, and health for modern lifestyles.',
  },
};

export const FoodoGlobalAr = {
  companyProfile: {
    name: 'فوودو جلوبال',
    about:
      'فوودو جلوبال هي شركة قطرية رائدة ومتخصصة بتوفير وجبات الطعام المطبوخة والجاهزة للتناول الفوري بنكهات خليجية وعربية وآسيوية عالمية أصيلة. نخدم الأفراد والمؤسسات المحلية والعالمية من خلال قنوات متعددة تشمل موقعنا الإلكتروني وتطبيقات التوصيل والأسواق المحلية والسوبر ماركت.',
    aboutMobile:
      'فوودو جلوبال هي شركة رائدة في تقديم وجبات جاهزة للتناول الفوري بنكهات متنوعة. نحن هنا لخدمتك في أي وقت.',
    certifications:
      'جميع وجباتنا معتمدة حلال وجاهزة للأكل بعد التسخين، مما يضمن وجبة كاملة وصحية في أي وقت.',
    specialization:
      'تتخصص فوودو في إنتاج الوجبات الجاهزة للأكل باستخدام تقنيات متطورة، وتوفر مجموعة واسعة من الأطباق المحلية والعالمية للإفطار والغداء والعشاء والمناسبات الخاصة.',
    whyChooseUs: [
      'جاهزة خلال 1-2 دقيقة فقط - مثالية للحياة العصرية السريعة.',
      'نكهات خليجية وعربية وآسيوية عالمية أصيلة.',
      'مرخصة من وزارة الصحة مع رقابة جودة صارمة.',
      'معتمدة حلال وطازجة ومصممة للحفاظ على القيمة الغذائية.',
      'صلاحية طويلة تصل إلى سنتين دون الحاجة للتبريد.',
      'تقنية التغليف الذكية لسهولة النقل والتخزين.',
      'طرق تسخين متعددة: ميكروويف، فرن، ماء ساخن، أو حقيبة التسخين الذاتي.',
      'مناسبة لجميع الظروف والأوقات.',
      'توفير المواد التموينية والسلال للمؤسسات والأفراد.',
      'متاحة عبر الموقع الإلكتروني والتطبيقات والأسواق وخدمة الاشتراك الشهري.',
      'معدة بمكونات طبيعية ودون مواد حافظة.',
      'تحتوي على جميع العناصر الغذائية الأساسية لنظام غذائي متوازن.',
      'مثالية للإفطار والغداء والعشاء والمناسبات الخاصة.',
    ],
    whyChooseUsMobile: [
      'جاهزة خلال 1-2 دقيقة فقط - مثالية للحياة العصرية السريعة.',
      'نكهات خليجية وعربية وآسيوية عالمية أصيلة.',
      'مرخصة من وزارة الصحة مع رقابة جودة صارمة.',
      'معتمدة حلال وطازجة ومصممة للحفاظ على القيمة الغذائية.',
      'صلاحية طويلة تصل إلى سنتين دون الحاجة للتبريد.',
    ],
    values: [
      'الالتزام بأعلى معايير الجودة في جميع وجباتنا.',
      'تقديم منتجات جديدة ومبتكرة تلبي احتياجات العملاء.',
      'تقديم وجبات مغذية خالية من المواد الحافظة / خالية من الغلوتين.',
      'تطبيق ممارسات صديقة للبيئة في جميع عملياتنا.',
      'وضع رضا العملاء في صميم كل ما نقدمه.',
    ],
    qualityStandards: [
      'وجبات معتمدة حلال على مستوى عالمي.',
      'تدابير صارمة لمراقبة سلامة الغذاء والجودة.',
      'مراقبة مستمرة للحفاظ على أعلى المعايير.',
    ],
    slogan: 'وجبات فوودو تمنحك تجربة فريدة بمذاق شهي في كل لقمة!',

    // Three Main Points Structure
    ourVision: {
      title: 'رؤيتنا',
      content: 'فوودو رائدة الوجبات النوعية والمذاق الإستثنائي العالمي، بجودة فائقة وتقنيات ذكية.',
    },
    ourMission: {
      title: 'رسالتنا',
      content:
        'إعادة تعريف الوجبات الجاهزة، بتقديم حلول غذائية مبتكرة ووجبات فاخرة ذات نكهات عالمية أصيلة، نعتمد على التقنية الذكية لضمان أعلى معايير الجودة وسلامة الغذاء وصلاحية ممتدة، لتمكين عملائنا من الاستمتاع بوجبة استثنائية في دقيقة واحدة.',
    },
    ourValues: {
      title: 'قيمنا',
      content: [
        'الالتزام بأعلى معايير الجودة في جميع وجباتنا.',
        'تقديم منتجات جديدة ومبتكرة تلبي احتياجات العملاء.',
        'تقديم وجبات مغذية خالية من المواد الحافظة / خالية من الغلوتين.',
        'تطبيق ممارسات صديقة للبيئة في جميع عملياتنا.',
        'وضع رضا العملاء في صميم كل ما نقدمه.',
      ],
    },

    // Legacy fields for backward compatibility
    vision: 'فوودو رائدة الوجبات النوعية والمذاق الإستثنائي العالمي، بجودة فائقة وتقنيات ذكية.',
    mission:
      'إعادة تعريف الوجبات الجاهزة، بتقديم حلول غذائية مبتكرة ووجبات فاخرة ذات نكهات عالمية أصيلة، نعتمد على التقنية الذكية لضمان أعلى معايير الجودة وسلامة الغذاء وصلاحية ممتدة، لتمكين عملائنا من الاستمتاع بوجبة استثنائية في دقيقة واحدة.',
    availability: {
      orderOnline: 'اطلب وجباتك المفضلة من متجرنا الإلكتروني واستمتع بتوصيل سريع داخل قطر.',
      location: 'الدوحة، قطر - الغرافة',
      contact: {
        phone: '+974 40171730',
        email: 'info@foodo.qa',
        website: 'www.foodo.qa',
      },
    },
    closingStatement:
      'في فوودو جلوبال، نقدم لك النكهات الخليجية والعربية والآسيوية الأصيلة في وجبات جاهزة تجمع بين الجودة والراحة والصحة لأنماط الحياة العصرية.',
  },
};
